export default __webpack_public_path__ + "static/media/placeholder_business01-jp-mobile.77d50672.png";